document.documentElement.classList.replace('no-js', 'js');

/* ---- */


    (() => {
      const shopToggle = document.querySelector('#shop-toggle');
      const megaMenu = document.querySelector('#shop-mega-menu');
      const aboutToggle = document.querySelector('#about-toggle');
      const aboutDropdown = document.querySelector('#about-dropdown');
      const aboutNav = document.querySelector('[data-about-nav]');
      const mobileToggle = document.querySelector('[data-mobile-toggle]');
      const mobileNavigation = document.querySelector('#mobile-navigation');
      const accordionToggles = [...document.querySelectorAll('[data-mobile-accordion]')];
      const wishlistButtons = [...document.querySelectorAll('[data-wishlist]')];
      const addOnButtons = [...document.querySelectorAll('[data-addon]')];
      const faqToggles = [...document.querySelectorAll('[data-faq-toggle]')];
      const newsletterForms = [...document.querySelectorAll('[data-newsletter-form]')];
      const footerToggles = [...document.querySelectorAll('[data-footer-toggle]')];
      const desktopMode = window.matchMedia('(min-width: 1401px)');
      const footerCompactMode = window.matchMedia('(max-width: 760px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const reducedMotionTestMode = new URLSearchParams(window.location.search).has('reduced-motion-test');
      const prefersReducedMotion = () => reducedMotion.matches || reducedMotionTestMode;
      let closeTimer;
      let aboutCloseTimer;
      let megaMenuTimeline;

      // Đổi icon bằng cách trỏ lại <use href> trong sprite, thay cho việc
      // bật/tắt class của Font Awesome.
      const hkSetIcon = (el, name) => {
        if (!el) return;
        const use = el.tagName.toLowerCase() === 'svg'
          ? el.querySelector('use')
          : el.querySelector('svg.hk-icon use');
        if (use) use.setAttribute('href', '#hk-i-' + name);
      };

      const carouselDefinitions = {
        shopping: { mobile: 1.4, tablet: 3, desktop: 5, label: 'gift categories' },
        products: { mobile: 1.2, tablet: 3, desktop: 5, label: 'personalized gifts' },
        products2: { mobile: 1.2, tablet: 3, desktop: 5, label: 'best sellers' },
        hawaiian: { mobile: 1.2, tablet: 3, desktop: 5, label: 'Hawaiian shirts' },
        testimonials: { mobile: 1.1, tablet: 2, desktop: 4, label: 'customer testimonials' },
        spotlight: { mobile: 1, tablet: 1, desktop: 1, label: 'new arrivals' }
      };
      const carouselCleanups = [];
      window.hakhatuCarousels = {};

      const bindCarouselInteractionState = (swiper, root) => {
        let pointerInside = false;
        let focusInside = false;
        let pageInactive = false;

        const syncAutoplay = () => {
          if (!swiper.autoplay) return;
          const mustStop = prefersReducedMotion() || document.hidden || pageInactive || pointerInside || focusInside;
          if (mustStop) swiper.autoplay.stop();
          else swiper.autoplay.start();
        };
        const onPointerEnter = () => { pointerInside = true; syncAutoplay(); };
        const onPointerLeave = () => { pointerInside = false; syncAutoplay(); };
        const onFocusIn = () => { focusInside = true; syncAutoplay(); };
        const onFocusOut = (event) => {
          focusInside = Boolean(event.relatedTarget && root.contains(event.relatedTarget));
          window.setTimeout(syncAutoplay, 0);
        };
        const onPageHide = () => { pageInactive = true; syncAutoplay(); };
        const onPageShow = () => { pageInactive = false; syncAutoplay(); };

        root.addEventListener('pointerenter', onPointerEnter);
        root.addEventListener('pointerleave', onPointerLeave);
        root.addEventListener('focusin', onFocusIn);
        root.addEventListener('focusout', onFocusOut);
        document.addEventListener('visibilitychange', syncAutoplay);
        window.addEventListener('pagehide', onPageHide);
        window.addEventListener('pageshow', onPageShow);
        reducedMotion.addEventListener('change', syncAutoplay);
        syncAutoplay();

        carouselCleanups.push(() => {
          root.removeEventListener('pointerenter', onPointerEnter);
          root.removeEventListener('pointerleave', onPointerLeave);
          root.removeEventListener('focusin', onFocusIn);
          root.removeEventListener('focusout', onFocusOut);
          document.removeEventListener('visibilitychange', syncAutoplay);
          window.removeEventListener('pagehide', onPageHide);
          window.removeEventListener('pageshow', onPageShow);
          reducedMotion.removeEventListener('change', syncAutoplay);
        });
      };

      const initCarousels = () => {
        if (typeof window.Swiper !== 'function') return;
        Object.entries(carouselDefinitions).forEach(([name, definition]) => {
          const root = document.querySelector(`[data-carousel="${name}"]`);
          if (!root) return;
          const slideCount = root.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
          const swiper = new window.Swiper(root, {
            slidesPerView: definition.mobile,
            spaceBetween: 16,
            speed: 700,
            loop: slideCount > definition.desktop,
            rewind: name === 'testimonials',
            autoplay: prefersReducedMotion() ? false : {
              delay: 4500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            },
            keyboard: { enabled: true, onlyInViewport: true },
            a11y: {
              enabled: true,
              containerMessage: `Carousel of ${definition.label}`,
              prevSlideMessage: `Previous ${definition.label}`,
              nextSlideMessage: `Next ${definition.label}`
            },
            navigation: {
              prevEl: root.querySelector(':scope > .swiper-button-prev'),
              nextEl: root.querySelector(':scope > .swiper-button-next')
            },
            pagination: {
              el: root.querySelector(':scope > .swiper-pagination'),
              clickable: true,
              dynamicBullets: false
            },
            breakpoints: {
              768: { slidesPerView: definition.tablet, spaceBetween: 20 },
              1401: { slidesPerView: definition.desktop, spaceBetween: 24 }
            }
          });
          window.hakhatuCarousels[name] = swiper;
          bindCarouselInteractionState(swiper, root);
        });
      };

      const initMotion = () => {
        if (!window.gsap || !window.ScrollTrigger) return;
        const { gsap, ScrollTrigger } = window;
        gsap.registerPlugin(ScrollTrigger);

        megaMenuTimeline = gsap.timeline({
          paused: true,
          onReverseComplete: () => {
            if (shopToggle.getAttribute('aria-expanded') === 'false') megaMenu.hidden = true;
          },
          defaults: { duration: 0.24, ease: 'power2.out' }
        }).fromTo(megaMenu, {
          autoAlpha: 0,
          y: -10
        }, {
          autoAlpha: 1,
          y: 0,
          immediateRender: false
        });

        const diagnostics = {
          ready: true,
          reducedMotion: prefersReducedMotion(),
          revealCount: 0,
          properties: ['autoAlpha', 'y', 'scale', 'rotation'],
          megaMenuTimeline
        };
        window.hakhatuMotion = diagnostics;

        const media = gsap.matchMedia();
        media.add({
          reduceMotion: '(prefers-reduced-motion: reduce)',
          canAnimate: '(prefers-reduced-motion: no-preference)'
        }, (context) => {
          if (context.conditions.reduceMotion || prefersReducedMotion()) {
            diagnostics.reducedMotion = true;
            diagnostics.revealCount = 0;
            return;
          }

          diagnostics.reducedMotion = false;
          // Hiệu ứng intro của header đã tắt: xem ghi chú trong fix-css.mjs.
          const HK_HEADER_BITS = ['.announcement-bar', '.brand', '.desktop-nav .nav-link', '.header-actions .action-button'];
          const intro = gsap.timeline();
          gsap.set(HK_HEADER_BITS, { clearProps: 'opacity,visibility,transform,translate,rotate,scale' });

          const revealSelectors = [
            '.hk-hero-copy', '.hero-media', '.shopping-header', '.shopping-grid',
            '.personalization-strip', '.most-loved-heading', '.product-grid', '.bundle-offer',
            '.recipient-heading', '.recipient-grid', '.workflow-visual', '.workflow-content',
            '.blanket-copy', '.blanket-addons', '.testimonials-heading', '.testimonial-grid',
            '.faq-newsletter-grid', '.footer-main'
          ];
          revealSelectors.forEach((selector) => {
            const target = document.querySelector(selector);
            if (!target) return;
            const groupItems = [...target.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide, :scope > .recipient-card, .workflow-card')];
            const animationTargets = groupItems.length ? groupItems : [target];
            ScrollTrigger.create({
              trigger: target,
              start: 'clamp(top 88%)',
              once: true,
              onEnter: () => gsap.fromTo(animationTargets, {
                autoAlpha: 0.92,
                y: 18
              }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.62,
                ease: 'power2.out',
                stagger: groupItems.length ? 0.075 : 0,
                clearProps: 'opacity,visibility,transform'
              })
            });
            diagnostics.revealCount += 1;
          });

          return () => {
            intro.kill();
            gsap.set(revealSelectors, { clearProps: 'opacity,visibility,transform' });
          };
        });

        let refreshFrame = 0;
        const refreshMotionLayout = () => {
          window.cancelAnimationFrame(refreshFrame);
          refreshFrame = window.requestAnimationFrame(() => ScrollTrigger.refresh());
        };
        window.refreshMotionLayout = refreshMotionLayout;
        if (document.fonts?.ready) document.fonts.ready.then(refreshMotionLayout);
        window.addEventListener('load', refreshMotionLayout, { once: true });
        Object.values(window.hakhatuCarousels).forEach((swiper) => {
          swiper.on('resize', refreshMotionLayout);
          swiper.on('imagesReady', refreshMotionLayout);
        });
      };

      const setAboutMenu = (open) => {
        const nextOpen = Boolean(open && desktopMode.matches);
        aboutToggle.setAttribute('aria-expanded', String(nextOpen));
        aboutDropdown.hidden = !nextOpen;
        if (nextOpen) setMegaMenu(false);
      };

      const setMegaMenu = (open) => {
        const nextOpen = Boolean(open && desktopMode.matches);
        shopToggle.setAttribute('aria-expanded', String(nextOpen));
        document.body.classList.toggle('mega-open', nextOpen);
        if (nextOpen) {
          setAboutMenu(false);
          megaMenu.hidden = false;
          if (megaMenuTimeline && !prefersReducedMotion()) megaMenuTimeline.restart();
          return;
        }
        if (!megaMenuTimeline || prefersReducedMotion() || megaMenu.hidden) {
          megaMenu.hidden = true;
          return;
        }
        if (megaMenuTimeline.progress() === 0) megaMenuTimeline.progress(1);
        megaMenuTimeline.reverse();
      };

      const setMobileMenu = (open) => {
        const nextOpen = Boolean(open && !desktopMode.matches);
        mobileToggle.setAttribute('aria-expanded', String(nextOpen));
        mobileToggle.setAttribute('aria-label', nextOpen ? 'Close menu' : 'Open menu');
        mobileNavigation.hidden = !nextOpen;
        document.body.classList.toggle('menu-lock', nextOpen);
      };

      const setFaqOpen = (toggle, open) => {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        const icon = toggle.querySelector('.faq-symbol');
        toggle.setAttribute('aria-expanded', String(open));
        hkSetIcon(icon, open ? 'minus' : 'plus');
        panel.hidden = !open;
      };

      const setFooterOpen = (toggle, open) => {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        const icon = toggle.querySelector('.footer-heading-symbol');
        toggle.setAttribute('aria-expanded', String(open));
        hkSetIcon(icon, open ? 'minus' : 'plus');
        panel.hidden = !open;
      };

      const syncFooterPanels = () => {
        footerToggles.forEach((toggle) => setFooterOpen(toggle, !footerCompactMode.matches));
      };

      const cancelScheduledClose = () => {
        window.clearTimeout(closeTimer);
      };

      const scheduleClose = () => {
        cancelScheduledClose();
        closeTimer = window.setTimeout(() => setMegaMenu(false), 140);
      };

      shopToggle.addEventListener('click', (event) => {
        event.stopPropagation();
        const isOpen = shopToggle.getAttribute('aria-expanded') === 'true';
        setMegaMenu(!isOpen);
      });

      shopToggle.addEventListener('pointerenter', () => {
        cancelScheduledClose();
        setMegaMenu(true);
      });
      shopToggle.addEventListener('pointerleave', scheduleClose);
      megaMenu.addEventListener('pointerenter', cancelScheduledClose);
      megaMenu.addEventListener('pointerleave', scheduleClose);

      const cancelAboutClose = () => window.clearTimeout(aboutCloseTimer);
      const scheduleAboutClose = () => {
        cancelAboutClose();
        aboutCloseTimer = window.setTimeout(() => setAboutMenu(false), 140);
      };

      aboutNav.addEventListener('pointerenter', () => {
        cancelAboutClose();
        setAboutMenu(true);
      });
      aboutNav.addEventListener('pointerleave', scheduleAboutClose);
      aboutNav.addEventListener('focusin', () => {
        cancelAboutClose();
        setAboutMenu(true);
      });
      aboutNav.addEventListener('focusout', (event) => {
        if (!aboutNav.contains(event.relatedTarget)) scheduleAboutClose();
      });

      mobileToggle.addEventListener('click', (event) => {
        event.stopPropagation();
        const isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
        setMobileMenu(!isOpen);
      });

      accordionToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const controlledId = toggle.getAttribute('aria-controls');
          const panel = document.getElementById(controlledId);
          const willOpen = toggle.getAttribute('aria-expanded') !== 'true';

          accordionToggles.forEach((otherToggle) => {
            const otherPanel = document.getElementById(otherToggle.getAttribute('aria-controls'));
            const isCurrent = otherToggle === toggle;
            otherToggle.setAttribute('aria-expanded', String(isCurrent && willOpen));
            hkSetIcon(otherToggle.lastElementChild, (isCurrent && willOpen) ? 'minus' : 'plus');
            otherPanel.hidden = !(isCurrent && willOpen);
          });

          panel.hidden = !willOpen;
        });
      });

      wishlistButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const nextPressed = button.getAttribute('aria-pressed') !== 'true';
          const icon = button.querySelector('.hk-icon');
          button.setAttribute('aria-pressed', String(nextPressed));
          hkSetIcon(icon, nextPressed ? 'heart-fill' : 'heart');
          button.setAttribute(
            'aria-label',
            button.getAttribute('aria-label').replace(nextPressed ? 'Add ' : 'Remove ', nextPressed ? 'Remove ' : 'Add ')
          );
        });
      });

      addOnButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const nextPressed = button.getAttribute('aria-pressed') !== 'true';
          const icon = button.querySelector('.hk-icon');
          button.setAttribute('aria-pressed', String(nextPressed));
          hkSetIcon(icon, nextPressed ? 'check' : 'plus');
          button.setAttribute('aria-label', `${nextPressed ? 'Remove' : 'Add'} ${button.dataset.addon}`);
        });
      });

      faqToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
          faqToggles.forEach((otherToggle) => setFaqOpen(otherToggle, otherToggle === toggle && willOpen));
        });
      });

      newsletterForms.forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const input = form.querySelector('input[type="email"]');
          const status = form.querySelector('[data-newsletter-status]');
          const valid = input.validity.valid && input.value.trim() !== '';
          status.dataset.state = valid ? 'success' : 'error';
          status.textContent = valid ? 'Thanks! You are on the list.' : 'Enter a valid email address.';
          input.setAttribute('aria-invalid', String(!valid));
        });
      });

      footerToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          if (!footerCompactMode.matches) return;
          setFooterOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
        });
      });

      document.addEventListener('click', (event) => {
        if (!megaMenu.contains(event.target) && !shopToggle.contains(event.target)) {
          setMegaMenu(false);
        }
        if (!aboutNav.contains(event.target)) {
          setAboutMenu(false);
        }
        if (!mobileNavigation.contains(event.target) && !mobileToggle.contains(event.target)) {
          setMobileMenu(false);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const mobileWasOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
        const megaWasOpen = shopToggle.getAttribute('aria-expanded') === 'true';
        const aboutWasOpen = aboutToggle.getAttribute('aria-expanded') === 'true';
        setMegaMenu(false);
        setAboutMenu(false);
        setMobileMenu(false);
        if (mobileWasOpen) mobileToggle.focus();
        if (megaWasOpen) shopToggle.focus();
        if (aboutWasOpen) aboutToggle.focus();
      });

      desktopMode.addEventListener('change', () => {
        setMobileMenu(false);
        setMegaMenu(false);
        setAboutMenu(false);
      });

      footerCompactMode.addEventListener('change', syncFooterPanels);

      initCarousels();
      initMotion();
      setMobileMenu(false);
      setMegaMenu(false);
      setAboutMenu(false);
      syncFooterPanels();
    })();